let user: { id: number; name?: string } | null = null;

export const joyrideService = {
    getUser: () => user,
    setUser: (newUser: { id: number; name?: string }) => {
        user = newUser;
    },
    clearUser: () => {
        user = null;
    },
};
